import { Link } from "react-router-dom";
import Services from "@/components/feature/Services";
import Industries from "@/components/feature/Industries";
import ServiceAreas from "@/components/feature/ServiceAreas";

export default function ServicesPage() {
  return (
    <>
      {/* Patrol Fleet Showcase - First & Hero Section */}
      <section className="relative py-20 md:py-28 bg-primary-700 overflow-hidden">
        {/* Background patrol vehicle image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-15"
          style={{
            backgroundImage:
              "url(/images/Askari-Security-patrol-vehicle.webp)",
          }}
        />
        <div className="relative z-10 px-4 md:px-6 lg:px-10">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
              <div>
                <span className="text-accent-400 text-xs md:text-sm font-semibold tracking-[0.3em] uppercase mb-6 block">
                  Professional Protection
                </span>
                <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
                  Patrol &amp; <span className="text-accent-400">Vehicle Services</span>
                </h1>
                <p className="text-background-50/80 text-base md:text-lg leading-relaxed mb-8 max-w-xl">
                  Our marked and unmarked security vehicles provide high-visibility
                  deterrence and rapid response across commercial properties,
                  residential communities, and construction sites. Each vehicle is
                  equipped with GPS tracking, two-way radio, and emergency lighting.
                </p>
                <div className="grid grid-cols-2 gap-4 mb-8">
                  <div className="bg-background-50/10 rounded-lg p-4 border border-background-50/20">
                    <div className="font-heading text-2xl font-bold text-accent-400 mb-1">&lt; 15 min</div>
                    <div className="text-background-50/60 text-xs">Average Response Time</div>
                  </div>
                  <div className="bg-background-50/10 rounded-lg p-4 border border-background-50/20">
                    <div className="font-heading text-2xl font-bold text-accent-400 mb-1">24/7</div>
                    <div className="text-background-50/60 text-xs">Patrol Coverage</div>
                  </div>
                  <div className="bg-background-50/10 rounded-lg p-4 border border-background-50/20">
                    <div className="font-heading text-2xl font-bold text-accent-400 mb-1">GPS</div>
                    <div className="text-background-50/60 text-xs">Tracked Fleet</div>
                  </div>
                  <div className="bg-background-50/10 rounded-lg p-4 border border-background-50/20">
                    <div className="font-heading text-2xl font-bold text-accent-400 mb-1">50+</div>
                    <div className="text-background-50/60 text-xs">Active Patrol Routes</div>
                  </div>
                </div>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold px-8 py-4 rounded-md transition-all duration-300 whitespace-nowrap text-sm"
                >
                  Request Patrol Services
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="/images/Askari-Security-patrol-vehicle.webp"
                  alt="Askari Security patrol vehicle"
                  className="w-full h-[350px] md:h-[450px] object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <Services />

      {/* Industries */}
      <Industries />

      {/* CTA Banner */}
      <section className="py-16 md:py-20 bg-background-100">
        <div className="px-4 md:px-6 lg:px-10 text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              Custom Security Solutions
            </h2>
            <p className="text-foreground-600 text-base mb-8 max-w-xl mx-auto leading-relaxed">
              Every business is unique. We build tailored security plans that fit your
              specific risks, budget, and operational requirements.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-8 py-4 rounded-md transition-all duration-300 whitespace-nowrap text-sm"
            >
              Get a Custom Quote
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <ServiceAreas />
    </>
  );
}